import React from "react";
import { SubscriptionEvents } from "@glamcorner/gc-types/generated/ipcBusEvents";
import { DesignationPanel, DesignationPanelField } from "../DesignationPanel";
import { SizeRow } from "../../SizeRow";
import { Bus } from "../../../../services/Bus";
import { useStyle } from "../../../context/StyleProvider";
import { useSession } from "../../../context/SessionProvider";
import { ExclusiveSubscriptionOnly } from "../../ExclusiveSubscriptionOnly";
import { SubscriptionService } from "../../../../services/SubscriptionService";
import { SubscriptionDesignationInformation } from "../../../../types";

export type SubscriptionDesignationPanelProps = {
  isSelected: boolean;
  onSelect: () => void;
  parentOnSubmitCallback: (callbackFn: () => boolean) => void;
  productCode: string | undefined;
  information: SubscriptionDesignationInformation;
  errors: { size?: string };
  isValid: () => boolean;
  size: string | undefined;
};

export const SubscriptionDesignationPanel: React.FC<SubscriptionDesignationPanelProps> = ({
  isSelected,
  onSelect,
  parentOnSubmitCallback,
  errors,
  isValid,
  productCode,
  information,
  size,
}) => {
  const { gcSession } = useSession();
  const { styleCode } = useStyle();

  parentOnSubmitCallback(() => {
    if (isValid()) {
      Bus.broadcast(SubscriptionEvents.AddToSubscriptionBox, {
        style: styleCode,
        size,
        productCode,
      });

      return true;
    }

    return false;
  });

  const sizeRowField: DesignationPanelField = {
    label: "Size",
    component: <SizeRow sizes={information.sizes} />,
    error: errors.size,
  };

  const fields = [[sizeRowField]];

  return (
    <DesignationPanel isSelected={isSelected} title="Membership" subTitle="" onSelect={onSelect} fields={fields}>
      {/* checking if gcSession is populated first, prevents CLS */}
      {gcSession && !SubscriptionService.isSubscriptionCustomer(gcSession) && <ExclusiveSubscriptionOnly />}
    </DesignationPanel>
  );
};
